import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import React, { useContext } from 'react';
import { I18n, I18nProvider } from 'frontend-i18n';
export { I18n, I18nProvider } from 'frontend-i18n';
import startsWith from '@andes/common/build/utils/startsWith';
import warning from '@andes/common/build/utils/warning';
import { useId as useId$2 } from '@react-aria/utils';
import _jsx from '@babel/runtime/helpers/jsx';
import { SSRProvider } from '@react-aria/ssr';
import isMobile from '@andes/common/build/utils/isMobile';
import getNativeApp from '@andes/common/build/utils/getNativeApp';
import getOsName from '@andes/common/build/utils/getOsName';
const EN_US = 'en-US';
const ES_AR = 'es-AR';
const PT_BR = 'pt-BR';
const getBestLocale = locale => {
  if (!locale) return ES_AR;
  if (startsWith(locale, 'en') || startsWith(locale, 'zh')) return EN_US;
  return locale === PT_BR ? PT_BR : ES_AR;
};
const injectTranslations = function (i18n, contextLocale) {
  for (var _len = arguments.length, availableTranslations = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    availableTranslations[_key - 2] = arguments[_key];
  }
  if (i18n && availableTranslations.length) {
    const bestLocale = getBestLocale(contextLocale);
    const componentTranslations = availableTranslations.find(_ref => {
      let {
        locale
      } = _ref;
      return locale === bestLocale;
    });
    const {
      module
    } = componentTranslations || {};
    if (!i18n.andes) i18n.andes = {};
    if (!i18n.andes[String(module)]) {
      i18n.translations = _objectSpread(_objectSpread({}, i18n.translations), componentTranslations === null || componentTranslations === void 0 ? void 0 : componentTranslations.translations);
      i18n.andes[String(module)] = true;
    }
  }
};
const getAndesContextValue = context => context && 'Consumer' in context ? useContext(context) : context;
const getPatchedI18n = function (andesContext) {
  var _availableTranslation;
  for (var _len2 = arguments.length, availableTranslations = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    availableTranslations[_key2 - 1] = arguments[_key2];
  }
  const module = ((_availableTranslation = availableTranslations[0]) === null || _availableTranslation === void 0 ? void 0 : _availableTranslation.module) || '@andes';
  let value = getAndesContextValue(andesContext) || {};
  if (!value || typeof value !== 'undefined' && Object.keys(value).length === 0) {
    warning(false, "".concat(module, " needs a valid configuration of <AndesProvider> on your application.\n    Check the documentation about @andes/context and <AndesProvider> on:\n    https://github.com/melisource/fury_frontend-andes-ui/blob/master/packages/context/README.md"));
    value = {
      i18n: new I18n({
        translations: {}
      }),
      locale: ES_AR
    };
  }
  const {
    i18n,
    locale
  } = value;
  injectTranslations(i18n, locale, ...availableTranslations);
  return i18n;
};
const generateId = value => {
  if (process.env.NODE_ENV !== 'test') return value;
  return typeof value === 'undefined' ? 'test-id' : value;
};
var generateId$1 = generateId;
const useId = id => {
  if (React.useId) {
    return generateId$1(id) || React.useId();
  }
  return useId$2(generateId$1(id));
};
var useId$1 = useId;
const AndesContext = /*#__PURE__*/React.createContext({});
var AndesContext$1 = AndesContext;
const getDevice = device => {
  if (typeof device !== 'undefined') return device;
  const basicDeviceData = {
    mobile: isMobile(),
    webView: typeof MobileWebKit !== 'undefined',
    nativeApp: getNativeApp(),
    osName: getOsName()
  };
  return basicDeviceData;
};
var getDevice$1 = getDevice;
const AndesProvider = /*#__PURE__*/function () {
  const AndesProvider = _ref => {
    let {
      children,
      locale,
      device,
      csrfToken
    } = _ref;
    const value = {
      locale,
      i18n: new I18n({
        translations: {}
      }),
      device: getDevice$1(device),
      csrfToken
    };
    const renderChildren = () => React.useId ? /*#__PURE__*/React.createElement(React.Fragment, null, React.Children.only(children)) : /*#__PURE__*/_jsx(SSRProvider, {}, void 0, React.Children.only(children));
    return /*#__PURE__*/_jsx(AndesContext$1.Provider, {
      value: value
    }, void 0, renderChildren());
  };
  AndesProvider.displayName = 'AndesProvider';
  return AndesProvider;
}();
var AndesProvider$1 = AndesProvider;
const {
  I18nContext
} = I18nProvider;
export { AndesContext$1 as AndesContext, AndesProvider$1 as AndesProvider, I18nContext, getPatchedI18n, injectTranslations, useId$1 as useId };
